import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from '../../labels/interviewProcess_en.json';
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getInterviweScheduleByExamId } from "../../actions/interviewProcessActions";
import { getYearList, getMainsAdvertisements } from "../../../common/actions/commonActions";
import moment from 'moment';


const InterviewScheduleList = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm(
    {
      mode: "onChange",
    }
  );

  let { getInterviewSchedule } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  let { advertisementList, examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [interviewData, setInterviewData] = useState([]);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    setReloadItem(!reloadItem);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getInterviewSchedule) {
      setInterviewData(getInterviewSchedule);
    }
  }, [getInterviewSchedule]);

  useEffect(() => {
    setPrintFlag(interviewData.length === 0);
  }, [interviewData]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    examList.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(true);
    setPrintFlag(true);
    setInterviewData([]);
    setReloadItem(!reloadItem);
  };


  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    setInterviewData([])
    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };
  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setInterviewData([]);
    setReloadItem(!reloadItem);
    examList.length = 0;
    getInterviewSchedule.length = 0;
  };

  const onSubmit = () => {
    dispatch(getInterviweScheduleByExamId(selectedExam));
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' + label.MPSC + '</h5><h5>' + getInterviewSchedule.examName + '</h5><h5>' + label.InterviewScheduleList + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const examName = getInterviewSchedule.examName;

    const options = {
      margin: [0.8, 0.2, 0.8, 0.2],
      filename: 'InterviewScheduleList.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = getInterviewSchedule.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`InterviewScheduleList_${examName}.pdf`);

      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };


  return (
    <div>
      <h5 > {label.GenerateInterviewScheduleList} </h5>

      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    // ref={register({ required: true })}
                    value={selectedYear}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option key={index}>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                    <>    <button
                      type="reset"
                      className="btn btn-secondary mr-2"
                      onClick={() => onCancelButton()}
                    >
                      {commonLabels.BUTTON_CANCEL}
                    </button>

                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={saveButtonFlag}
                        onClick={handleSubmit((e) => {
                          onSubmit(e);
                          setConfirmClicked(true);
                        })}
                      >
                        {commonLabels.BUTTON_VIEW}
                      </button></>}

                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={printFlag || !confirmClicked}
                    onClick={() => {
                      downloadPdf();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {selectedExam && interviewData && interviewData.interviewCenters && interviewData.interviewCenters.length > 0 && (
        <div ref={pdfRef} className="answerKeyTable" id="interviewList">

          <div className="container">
            {getInterviewSchedule.interviewCenters.map((center, centerIndex) => (
              <div key={centerIndex} className="my-3">
                <h5 className="text-center"><strong>INTERVIEW CENTER : </strong>{center.centerName}</h5>
                {center.venues.map((venue, venueIndex) => (
                  <div key={venueIndex} className="my-2">
                    <p><strong>VENUE : </strong>{venue.venueName}</p>
                    {venue.interviewDates.map((date, dateIndex) => {
                      const totalCandidates = date.committeeList.reduce((total, committee) => total + committee.interviewTimes[0].noOfCandidate, 0);
                      return (
                        <div key={dateIndex} className="my-2">

                          <table className="table text-center">
                            <thead>
                              <tr>
                                <th>Date: {moment(date.interviewDate, "DD-MM-YYYY").format("DD/MM/YYYY")}</th>
                                <th>Interview Time</th>
                                <th>Interview No From</th>
                                <th>Interview No To</th>
                                <th>No of Candidates</th>
                              </tr>
                            </thead>
                            <tbody>
                              {date.committeeList.map((committee, committeeIndex) => (
                                <tr key={committeeIndex}>
                                  <td>Committee: {committee.committee}</td>
                                  <td>{committee.interviewTimes[0].interviewTime}</td>
                                  <td>{committee.interviewTimes[0].interviewNoFrom}</td>
                                  <td>{committee.interviewTimes[0].interviewNoTo}</td>
                                  <td>{committee.interviewTimes[0].noOfCandidate}</td>
                                </tr>
                              ))}
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><strong>Day Count : </strong>{totalCandidates}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                ))}
                <hr className="mar_top_bottom_8" />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InterviewScheduleList;
